export const environment = {
  configUrl: 'assets/config.json',
  production: true,
};
